import axios from 'axios';

let onUnauthorized = null;

export const registerUnauthorizedHandler = (handler) => {
  onUnauthorized = handler;
};

export const axiosInstance = axios.create({
  baseURL: '/api',
});

axiosInstance.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = 'Bearer ' + token;
      config.headers.Accept = 'application/json';
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    // Only treat 401 as session-expired when a token was actually sent —
    // otherwise bad-credentials on login would trigger a logout loop.
    if (
      error.response?.status === 401 &&
      localStorage.getItem('token') &&
      onUnauthorized
    ) {
      onUnauthorized();
    }
    return Promise.reject(error.response);
  }
);
